/*
import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { axiosInstance } from '../../../../lib/axiosInstance.js';
import styles from './friends.module.css';
import Avatar from '@mui/material/Avatar';
import { IoMdClose } from "react-icons/io";
import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';

function Friends(props) {
  const showFriendsListRef = useRef(null);
  const { setShowFriendsList, clickedGridTimeInDayHourMinute } = useGlobalState();

  const [friends, setFriends] = useState([]);
  const [profileDetails, setProfileDetails] = useState({});
  const [loading, setLoading] = useState({});
  const [isBooked, setIsBooked] = useState({});

  useEffect(() => {
    // Close when clicking outside
    function handleClickOutside(event) {
      if (
        showFriendsListRef.current &&
        !showFriendsListRef.current.contains(event.target)
      ) {
        setShowFriendsList(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowFriendsList]);

  useEffect(() => {
    // Fetch friends
    async function fetchFriends() {
      try {
        const friendsRes = await axiosInstance.get('/friends');
        setFriends(friendsRes.data);
      } catch (error) {
        console.error('Error fetching friends:', error);
      }
    }
    fetchFriends();
  }, []);

  useEffect(() => {
    // Fetch each friend's profile to get image & availability
    async function fetchProfiles() {
      const details = {};
      for (const friend of friends) {
        try {
          const profileRes = await axiosInstance.get(`/profile/?userID=${friend.id}`);
          details[friend.id] = profileRes.data; // e.g. { name, availableTimes, ... }
        } catch (error) {
          console.error('Error fetching friend details:', error);
        }
      }
      setProfileDetails(details);
    }
    if (friends.length > 0) {
      fetchProfiles();
    }
  }, [friends]);

  function isTimeWithinAvailableTimes(availableTimes) {
    // Check if clickedGridTimeInDayHourMinute fits in any of the available time slots
    // Adjust logic as needed based on how "availableTimes" is structured
    if (!availableTimes || !Array.isArray(availableTimes) || availableTimes.length === 0) return true;   //If availableTimes is not given, then the friend is available all the time.
    const { hour, minute } = clickedGridTimeInDayHourMinute;
    // Example: if availableTimes = [{ startHour: 14, endHour: 19 }, ... ]
    return availableTimes.some(slot => hour >= slot.startHour && hour <= slot.endHour); // && minute >= slot.startMinute && minute <= slot.endMinute  //What does some do? It checks if atleast one element in the array satisfies the condition.
  }

  async function handleDirectBook(friendId) {
    setLoading(prev => ({ ...prev, [friendId]: true }));
    try {
      // Only book if time is within friend's available times
      const friendInfo = profileDetails[friendId];
      if (friendInfo && isTimeWithinAvailableTimes(friendInfo.availableTimes)) {
        await axiosInstance.post('/sessions/requests', { friendId });  //This should actually be sessionId. A new API need to be made I guess. Because we need to send notification to the friend.
        setIsBooked(prev => ({ ...prev, [friendId]: true }));
        setShowFriendsList(false);
      } else {
        alert('This friend is not available at the selected time.');
      }
    } catch (error) {
      console.error('Error booking with friend:', error);
    } finally {
      setLoading(prev => ({ ...prev, [friendId]: false }));
    }
  }

  return (
    <div ref={props.friendsExpansionRef} className={styles.friends_list}>
      <div className={styles.title_and_close_icon_div}>
        <h2 className={styles.h2}>Friends</h2>
        <IoMdClose onClick={()=>props.setShowFriends(false)} className={styles.close_icon}/>
      </div>

      {friends.map(friend => {
        const details = profileDetails[friend.id] || {};
        return (
          <div className={styles.person_details_div} key={friend.id}>
            <div className={styles.person_avatar_name_div}>
              <Avatar
                className={styles.avatar_class}
                alt={friend.name}
                src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${friend.id}&type=thumbnail`}
              />
              <p className={styles.person_name_class}>{friend.name}</p>
            </div>
            <div className={styles.person_topic_book_button_div}>
              <div>
                {(details.availableTimes && Array.isArray(details.availableTimes) && details.availableTimes.length > 0) ? (
                  details.availableTimes.map((slot, i) => (
                    <p key={i} className={styles.person_available_time_class}>
                      {slot.startHour} - {slot.endHour}
                    </p>
                  ))
                ) : (
                  <p className={styles.person_available_time_class}>Not given</p>
            )}
              </div>
              <button
                className={styles.friends_book_button}
                disabled={loading[friend.id] || isBooked[friend.id]}
                onClick={() => handleDirectBook(friend.id)}
              >
                {loading[friend.id] ? 'Booking...' : isBooked[friend.id] ? 'Booked' : 'Book'}
              </button>
            </div>
          </div>
        );
      })}

      <Link className={styles.invite_friends_button} to="/invite_friends">
        Invite your friends
      </Link>
    </div>
  );
}

export default Friends;
*/










import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { axiosInstance } from '../../../../lib/axiosInstance.js';
import styles from './friends.module.css';
import Avatar from '@mui/material/Avatar';
import { IoMdClose } from "react-icons/io";
import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';

function Friends(props) {
  const showFriendsListRef = useRef(null);
  const { setShowFriendsList, clickedGridTimeInDayHourMinute } = useGlobalState();

  const [activeTab, setActiveTab] = useState('friends');  
  const [friends, setFriends] = useState([]);
  const [receivedRequests, setReceivedRequests] = useState([]);
  const [sentRequests, setSentRequests] = useState([]);

  const [profileDetails, setProfileDetails] = useState({});
  const [loading, setLoading] = useState({});
  const [isBooked, setIsBooked] = useState({});

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (showFriendsListRef.current && !showFriendsListRef.current.contains(event.target)) {
        props.setShowFriends(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props]);

  // Fetch friends
  useEffect(() => {
    async function fetchFriends() {
      try {
        const res = await axiosInstance.get('/friends');
        setFriends(res.data);
      } catch (error) {
        console.error('Error fetching friends:', error);
      }
    }
    if (activeTab === 'friends') {
      fetchFriends();
    }
  }, [activeTab]);

  // Fetch received requests
  useEffect(() => {
    async function fetchReceivedRequests() {
      try {
        const res = await axiosInstance.get('/friends/requests'); 
        setReceivedRequests(res.data);
      } catch (error) {
        console.error('Error fetching received requests:', error);
      }
    }
    if (activeTab === 'received') {
      fetchReceivedRequests();
    }
  }, [activeTab]);

  // Fetch sent requests
  useEffect(() => {
    async function fetchSentRequests() {
      try {
        const res = await axiosInstance.get('/friends/requests/sent'); 
        setSentRequests(res.data);
      } catch (error) {
        console.error('Error fetching sent requests:', error);
      }
    }
    if (activeTab === 'sent') {
      fetchSentRequests();
    }
  }, [activeTab]);

  // Fetch each friend's profile
  useEffect(() => {
    async function fetchProfiles() {
      const details = {};
      for (const friend of friends) {
        try {
          const profileRes = await axiosInstance.get(`/profile/?userID=${friend.id}`);
          details[friend.id] = profileRes.data;
        } catch (error) {
          console.error('Error fetching friend details:', error);
        }
      }
      setProfileDetails(details);
    }
    if (friends.length > 0 && activeTab === 'friends') {
      fetchProfiles();
    }
  }, [friends, activeTab]);

  function isTimeWithinAvailableTimes(availableTimes) {
    // Example check
    return !!availableTimes;
  }

  async function handleDirectBook(friendId) {
    setLoading(prev => ({ ...prev, [friendId]: true }));
    try {
      const friendInfo = profileDetails[friendId];
      if (friendInfo && isTimeWithinAvailableTimes(friendInfo.availableTimes)) {
        await axiosInstance.post('/sessions/requests', { friendId });
        setIsBooked(prev => ({ ...prev, [friendId]: true }));
        setShowFriendsList(false);
      } else {
        alert('This friend is not available at the selected time.');
      }
    } catch (error) {
      console.error('Error booking with friend:', error);
    } finally {
      setLoading(prev => ({ ...prev, [friendId]: false }));
    }
  }

  async function acceptRequest(reqId) {
    try {
      await axiosInstance.post(`/friends/requests/accept/${reqId}`);
      setReceivedRequests(prev => prev.filter(req => req.reqId !== reqId));
    } catch (error) {
      console.error('Error accepting request:', error);
    }
  }

  async function rejectRequest(reqId) {
    try {
      await axiosInstance.post(`/friends/requests/reject/${reqId}`);
      setReceivedRequests(prev => prev.filter(req => req.reqId !== reqId));
    } catch (error) {
      console.error('Error rejecting request:', error);
    }
  }

  return (
    <div ref={props.friendsExpansionRef} className={styles.friends_list}>
      <div className={styles.title_and_close_icon_div}>
        <h2 className={styles.h2}>Friends</h2>
        <IoMdClose onClick={() => props.setShowFriends(false)} className={styles.close_icon}/>
      </div>

      {/* Tabs */}
      <div className={styles.tabs}>
        <button
          className={activeTab === 'friends' ? styles.activeTab : ''}
          onClick={() => setActiveTab('friends')}
        >
          Friends
        </button>
        <button
          className={activeTab === 'received' ? styles.activeTab : ''}
          onClick={() => setActiveTab('received')}
        >
          Received requests
        </button>
        <button
          className={activeTab === 'sent' ? styles.activeTab : ''}
          onClick={() => setActiveTab('sent')}
        >
          Sent requests
        </button>
      </div>

      {/* Friends List */}
      {activeTab === 'friends' && friends.map(friend => {
        const details = profileDetails[friend.id] || {};
        return (
          <div className={styles.person_details_div} key={friend.id}>
            <div className={styles.person_avatar_name_div}>
              <Avatar
                className={styles.avatar_class}
                alt={friend.name}
                src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${friend.id}&type=thumbnail`}
              />
              <p className={styles.person_name_class}>{friend.name}</p>
            </div>
            <div className={styles.person_topic_book_button_div}>
              <div>
                {(details.availableTimes && Array.isArray(details.availableTimes)) ? (
                  details.availableTimes.map((slot, i) => (
                    <p key={i} className={styles.person_available_time_class}>
                      {slot.startHour} - {slot.endHour}
                    </p>
                  ))
                ) : (
                  <p className={styles.person_available_time_class}>Not given</p>
                )}
              </div>
              <button
                className={styles.friends_book_button}
                disabled={loading[friend.id] || isBooked[friend.id]}
                onClick={() => handleDirectBook(friend.id)}
              >
                {loading[friend.id] ? 'Booking...' : isBooked[friend.id] ? 'Booked' : 'Book'}
              </button>
            </div>
          </div>
        );
      })}

      {/* Received requests */}
      {activeTab === 'received' && receivedRequests.map((req) => (
        <div className={styles.person_details_div} key={req.reqId}>
          <p>{req.reqId}</p>
          <div>
            <button
              className={styles.friends_book_button}
              onClick={() => acceptRequest(req.reqId)}
            >
              Accept
            </button>
            <button
              className={styles.friends_book_button}
              style={{ marginLeft: '10px' }}
              onClick={() => rejectRequest(req.reqId)}
            >
              Reject
            </button>
          </div>
        </div>
      ))}

      {/* Sent requests */}
      {activeTab === 'sent' && sentRequests.map((req) => (
        <div className={styles.person_details_div} key={req.reqId}>
          <p>{req.reqId}</p>
        </div>
      ))}

      <Link className={styles.invite_friends_button} to="/invite_friends">
        Invite your friends
      </Link>
    </div>
  );
}

export default Friends;



